import { Component, h, Prop, State, Event, EventEmitter, Method } from '@stencil/core';
import { isBreakpointSmaller } from '../../../utils';

@Component({
  tag: 'dc-ui-header-burger',
  styleUrl: 'dc-ui-header-burger.scss',
  shadow: true,
})
export class DcUiHeaderBurger {
  @Prop({ reflect: true }) open: boolean = false;
  @Prop() label?: string;

  @State() iconSize: 'medium' | 'large' = this.getIconSize();
  @Event() dcHeaderBurgerClick: EventEmitter<boolean>;

  @Method()
  async dcToggleBurger() {
    this.open = !this.open;
  }

  componentDidLoad() {
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  private getIconSize() {
    return isBreakpointSmaller('md') ? 'medium' : 'large';
  }

  private readonly handleResize = () => {
    this.iconSize = this.getIconSize();
  };

  private readonly handleClick = () => {
    this.open = !this.open;
    this.dcHeaderBurgerClick.emit(this.open);
  };

  render() {
    return (
      <button
        onClick={this.handleClick}
        aria-label={this.label}>
        <dc-ui-icon
          name={this.open ? 'dc_close' : 'dc_list_mobile'}
          size={this.iconSize}></dc-ui-icon>
      </button>
    );
  }
}
